import { render, staticRenderFns } from "./CriteriaGroupedPlzSubmit.vue?vue&type=template&id=3e794c90&scoped=true"
import script from "./CriteriaGroupedPlzSubmit.vue?vue&type=script&lang=js"
export * from "./CriteriaGroupedPlzSubmit.vue?vue&type=script&lang=js"
import style0 from "./CriteriaGroupedPlzSubmit.vue?vue&type=style&index=0&id=3e794c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e794c90",
  null
  
)

export default component.exports